import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { CrossIcon } from "@/shared/icons";
import { TriangleArrowLeftIcon } from "@/shared/icons/TriangleArrowLeftIcon";
import { SoundButton } from "@/shared/ui";
import Button from "@/shared/ui/button/Button";

type Props = {
  logo: string;
  headerBg: string;
  isCart: boolean;
  setIsCart: (open: boolean) => void;
  onClose: () => void;
};

export default function ShopHeader({ logo, headerBg, isCart, setIsCart, onClose }: Props) {
  const { t } = useTranslation("shop");
  return (
    <header
      className={clsx(
        "flex items-center pl-7.5 pr-7.5 rounded-l-4 rounded-tr-4",
        headerBg ? "h-[6.25rem]" : "h-[5.125rem]",
        headerBg && "mb-7.5",
      )}
      style={{ background: `url(${headerBg})` }}
    >
      <div className="w-[12.5rem] mr-5">
        <img src={logo} alt="logo" />
      </div>
      <div className="flex items-center gap-2.5">
        {isCart && (
          <Button
            className="size-8 ml-auto p-0 rounded-xl bg-dark-800 hover:brightness-110"
            variant="soft"
            onClick={() => setIsCart(false)}
          >
            <TriangleArrowLeftIcon className="size-2.5" />
          </Button>
        )}
        <p className="text-18 font-bold">{isCart ? t("cart.cart") : t("title")}</p>
      </div>
      <SoundButton
        className="size-8 ml-auto p-0 rounded-xl bg-dark-800 hover:brightness-110"
        variant="soft"
        onClick={onClose}
      >
        <CrossIcon className="size-3" />
      </SoundButton>
    </header>
  );
}
